import { mapState } from 'vuex';
import ColorsMixin from '@/mixins/colors.mixin';
export default {
  name: 'CoreColorPicker',
  mixins: [ColorsMixin],
  props: {
    value: {
      type: String,
      required: false,
      default: null
    },
    dataCy: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    swatches() {
      const hexColors = this.colors.map(color => color.value);
      // return a matrix with 4 columns
      const matrix = [];
      for (let i = 0; i < hexColors.length; i += 4) {
        matrix.push(hexColors.slice(i, i + 4));
      }

      // Transpose the matrix
      const transposedMatrix = matrix[0].map((_, colIndex) => matrix.map(row => row[colIndex]));

      // remove unefined entries in every dimension
      return transposedMatrix.map(row => row.filter(col => col !== undefined));
    }
  },
  methods: {
    updateValue(value) {
      const color = typeof value === 'string' ? value : value.hexa;
      this.$emit('input', color);
    }
  }
};